import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { function_calcular_dias_ordinarios } from "../../../../functions/DatesFunctions";
import { DetalleDiasVacacionesSolicitados, HorarioLaboralServidorPermisosHoras, InformacionDetalleHistorialSolicitudVacaciones, InformacionDiaPermisoVacaciones, InformacionGeneralSolicitudes, SolicitudReintegroVacacionesPost, SolicitudReplanificacionVacacionesPost, SolicitudVacaciones, SolicitudVacacionesAnulacionPost, SolicitudVacacionesPost, TablaDetalleHistorialSolicitudVacaciones } from "./TypesSolicitudVacaciones";

export async function ObtenerInformacionGeneralSolicitudes(handleError: (info?: any) => void) {
    const url = configData.SERVER_URL + "SolicitudVacaciones/InformacionGeneral";
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionVacaciones: InformacionGeneralSolicitudes = { 
        planificaciones: [],
        planificacionesNoEjecutadas:[] ,
        fechasPermisos:[], 
        solicitudes: [],
        solicitudesReintegro:[], 
        solicitudReplanificacionIngresada:null,
        diasPendientes:-1,anio:-1 ,feriados:[],fechasLicencia:[],
        historial:[],
        esSubrogante:false,
        acuerdoMediosElectronicos:true,
        historialReplanificacion:[],
        horaEntrada:"",
        horaSalida:"",
        nroMaximoDiasOrdinariosImputablesVacaciones:22,
        tiempoAlmuerzo:"",
        horaFinAlmuerzo:"",
        horaInicioAlmuerzo:"",
        fechaCorteSoloJustificaPlanificacion:new Date(),
        esAprobador:false,
        cantidadMinutosMinimosPermisos: 5,
        usuarioNoPuedeSolicitarPorAccionPersonal:false,
        fechaHoraActual:new Date().toISOString(),
        nroDiasAnticipacionReplanificacion:10,
        idRegimenLaboralSolicitaVacaciones:-1,
        fechafincontrato: null,
        puedeSolicitarPorHorario:false
    }
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionVacaciones }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        informacionVacaciones = respuesta.data;
        
       if(informacionVacaciones.solicitudes.length > 0){
            const solicitudesMapping:SolicitudVacaciones[] = informacionVacaciones.solicitudes.map((val,ind) =>{
                return (
                    {
                        ...val,
                        nuevas:val.idSolicitud === undefined
                    }
                )
            })
            informacionVacaciones = {...informacionVacaciones,solicitudes:solicitudesMapping}
       } 
       
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionVacaciones,
        }




    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionVacaciones,
                errorMessage: error.response.data ?? ""
            }
            handleError(infoResponse.errorMessage);
        }
        else {
            handleError();
        }
    }

    return infoResponse;

}

export async function SolicitarVacacionesFormulario(solicitud:SolicitudVacacionesPost,  acuerdoMediosElectronicos:boolean){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    var URL_DOCUMENTO = "";

    // if (acuerdoMediosElectronicos && !solicitud.PermisoPorHora &&   (!solicitud.PermisoPorDia || (solicitud.PermisoPorDia && solicitud.NroDiasOrdinarios > 1))  ) {
    //     URL_DOCUMENTO = "SolicitudVacaciones/SolicitarVacaciones/VistaPreviaFormulario"
    // }
    // else {
    //     URL_DOCUMENTO = "SolicitudVacaciones/SolicitarVacaciones/FormularioVacaciones"
    // }

    URL_DOCUMENTO = "SolicitudVacaciones/SolicitarVacaciones/FormularioVacaciones"


    const url = `${configData.SERVER_URL}${URL_DOCUMENTO} ` 
    try {
        const respuesta = await axios.post(url,solicitud,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                    responseType:"blob"
                }
            )

            const blob_resource = await respuesta.data;
            const url_documento = window.URL.createObjectURL(blob_resource);
        respuestaResponse = {status:respuesta.status,dataResponse:url_documento}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();    

            respuestaResponse = {status:error.response.status,errorMessage:mensaje}
        }
        else if (axios.isAxiosError(error) && !error.response){
            respuestaResponse = {status:-1,errorMessage:"No ha sido posible contactar con el servidor. Intente más tarde."}
        }
    }
    return respuestaResponse
}

export async function SolicitarVacacionesCreacion(solicitud:SolicitudVacacionesPost){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    const url = configData.SERVER_URL + "SolicitudVacaciones/SolicitarVacaciones/CrearSolicitud"
    try {
        const respuesta = await axios.post(url,solicitud,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                }
            )
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }
    return respuestaResponse
}

export async function AnularSolicitudVacaciones(idSolicitud:number){
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = configData.SERVER_URL + `SolicitudVacaciones/AnularSolicitudVacaciones/${idSolicitud}`

    try {
        const respuesta = await axios.put(URL,{},{
            headers:authHeaderWithToken(infoUsuario.token)
        })

        return 1
    } catch (error) {
        return -1

    }


}

export async function AnularSolicitudReintegroVacaciones(idSolicitud:number){
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = configData.SERVER_URL + `SolicitudVacaciones/AnularSolicitudReintegroVacaciones/${idSolicitud}`

    try {
        const respuesta = await axios.put(URL,{},{
            headers:authHeaderWithToken(infoUsuario.token)
        })

        return 1
    } catch (error) {
        return -1

    }


}

export async function AnularSolicitudReplanificacionVacaciones(idSolicitud:number){
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = configData.SERVER_URL + `SolicitudReplanificacionVacaciones/Anulacion/${idSolicitud}`

    try {
        const respuesta = await axios.put(URL,{},{
            headers:authHeaderWithToken(infoUsuario.token)
        })

        return 1
    } catch (error) {
        return -1

    }


}

export async function AnularSolicitudVacacionesAprobada(solicitud:SolicitudVacacionesAnulacionPost){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    const url = configData.SERVER_URL + "SolicitudVacaciones/SolicitarAnulacion/CrearSolicitud"
    try {
        const respuesta = await axios.post(url,solicitud,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                }
            )
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }
    return respuestaResponse
}

export async function SolicitarReintegroVacaciones(solicitud:SolicitudReintegroVacacionesPost){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequestGeneric<{esPermiso:boolean}>= {status:-1}

    const url = configData.SERVER_URL + "SolicitudVacaciones/SolicitarReintegro/CrearSolicitud"
    try {
        const respuesta = await axios.post(url,solicitud,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                }
            )
        
        const objetoRequest: {esPermiso:boolean} = respuesta.data;

        respuestaResponse = {status:respuesta.status,dataResponse:objetoRequest}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }
    return respuestaResponse
}


export async function ObtenerDetalleHistorial(anio:number){
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var respuestaResponse:ResponseRequest = {status:-1}
    const URL_HISTORIAL_DETALLE = configData.SERVER_URL + "SolicitudVacaciones/DetalleHistorial/" + anio
    try {
        const respuesta = await axios.get(URL_HISTORIAL_DETALLE,{
            headers:authHeaderWithToken(infoUsuario.token)
        })    

        const dataResponse:InformacionDetalleHistorialSolicitudVacaciones = respuesta.data;
        
        respuestaResponse ={
            status:respuesta.status,
            dataResponse
        }

    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status}
        }
    } 

    return respuestaResponse;
    
}

export async function ObtenerVistaPreviaDocumentoSolicitudVacaciones(idSolicitud:number){
    const URL = `${configData.SERVER_URL}SolicitudVacaciones/VistaPreviaSolicitud/${idSolicitud}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    try {
        const respuesta = await axios.get(URL,{
            headers:authHeaderWithToken(infoUsuario.token),
            responseType:"blob"
        })
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}


    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }
    return respuestaResponse;
}

export async function ObtenerVistaPreviaDocumentoSolicitudReintegroVacaciones(idSolicitud:number){
    const URL = `${configData.SERVER_URL}SolicitudVacaciones/VistaPreviaSolicitud/SolicitudReintegro/${idSolicitud}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    try {
        const respuesta = await axios.get(URL,{
            headers:authHeaderWithToken(infoUsuario.token),
            responseType:"blob"
        })
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}


    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }
    return respuestaResponse;
}

export async function ObtenerVistaPreviaDocumentoSolicitudReplanificacion(idSolicitud:number){
    const URL = `${configData.SERVER_URL}SolicitudReplanificacionVacaciones/Formulario/${idSolicitud}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    try {
        const respuesta = await axios.get(URL,{
            headers:authHeaderWithToken(infoUsuario.token),
            responseType:"blob"
        })
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}


    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }
    return respuestaResponse;
}


export async function ObtenerVistaAccionPersonalSolicitudReintegroVacaciones(solicitud:SolicitudReintegroVacacionesPost){
    const URL = `${configData.SERVER_URL}SolicitudVacaciones/SolicitarReintegro/VistaPreviaAccion`;
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    try {
        const respuesta = await axios.post(URL,solicitud,
            {
                headers:authHeaderWithToken(infoUsuario.token),
                responseType:"blob"
            })

        
        const url = window.URL.createObjectURL(respuesta.data);

        respuestaResponse = {status:respuesta.status,dataResponse:url}


    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            const mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();    

            respuestaResponse = {status:error.response.status,errorMessage:mensaje}
            
        }
        else if (axios.isAxiosError(error) && !error.response){
            respuestaResponse = {status:-1,errorMessage:"No ha sido posible conectarse con el servidor"}

        }
        else{
            respuestaResponse = {status:-1,errorMessage:"Ha ocurrido un inconveniente"}
        }
    }
    return respuestaResponse;
}



export async function CrearSolicitudReplanificacionVacaciones(solicitud:SolicitudReplanificacionVacacionesPost){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequest = {status:-1}

    const url = configData.SERVER_URL + "SolicitudReplanificacionVacaciones/"
    try {
        const respuesta = await axios.post(url,solicitud,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                }
        )
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }

    return respuestaResponse;
}


export async function ObtenerHorarioLaboralEnFecha(fechaConsulta:Date){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequestGeneric<HorarioLaboralServidorPermisosHoras|null> = {status:-1}

    const fechaParse = `${fechaConsulta.getFullYear()}-${fechaConsulta.getMonth() + 1}-${fechaConsulta.getDate()}`
    
    const url = configData.SERVER_URL + "SolicitudVacaciones/HorarioLaboralServidor/" + fechaParse
    try {
        const respuesta = await axios.get(url,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                }
        )
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }

    return respuestaResponse;
}

export async function ObtenerInformacionDiaPermiso(fechaConsulta:Date){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequestGeneric<InformacionDiaPermisoVacaciones|null> = {status:-1}

    const fechaParse = `${fechaConsulta.getFullYear()}-${fechaConsulta.getMonth() + 1}-${fechaConsulta.getDate()}`
    
    const url = configData.SERVER_URL + "SolicitudVacaciones/InformacionDiaPermiso/" + fechaParse
    try {
        const respuesta = await axios.get(url,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                }
        )
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }

    return respuestaResponse;
}


export async function ObtenerDetalleDiasSolicitarVacaciones(fechaDesde:Date,fechaHasta:Date){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse:ResponseRequestGeneric<DetalleDiasVacacionesSolicitados> = {status:-1}

    const fechaDesdeParse = `${fechaDesde.getFullYear()}-${fechaDesde.getMonth() + 1}-${fechaDesde.getDate()}`
    const fechaHastaParse = `${fechaHasta.getFullYear()}-${fechaHasta.getMonth() + 1}-${fechaHasta.getDate()}`


    const url = configData.SERVER_URL + "SolicitudVacaciones/DetalleDiasSolicitudVacaciones/" 
    try {
        const respuesta = await axios.get(url,
                {
                    headers:authHeaderWithToken(infoUsuario.token),
                    params:{
                        fechaDesde:fechaDesdeParse,
                        fechaHasta:fechaHastaParse
                    }
                }
        )
        respuestaResponse = {status:respuesta.status,dataResponse:respuesta.data}
        
    } catch (error) {
        if(axios.isAxiosError(error) && error.response){
            respuestaResponse = {status:error.response.status,errorMessage:error.response.data}

        }
    }

    return respuestaResponse;
}